import { primaryColors } from '@/assets/styles/helpers/colors.styles'
import styles from './OrderTile.module.scss'

interface OrderTileProps {
  title: string
  description?: string
  backgroundColor?: string
  backgroundImage?: string
  index?: number
  onClick?: (index: number) => void
  selected?: boolean
}

function OrderTile(props: OrderTileProps) {
  const {
    title,
    description,
    backgroundColor,
    backgroundImage,
    index,
    onClick,
    selected
  } = props

  return (
    <div
      className={styles.orderTileWrapper}
      style={{
        backgroundColor: backgroundColor || 'transparent',
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        border: selected ? `2px solid ${primaryColors.white}` : 'none',
        padding: selected ? '0.375rem' : '0.5rem'
      }}
      role="button"
      tabIndex={0}
      onClick={() => onClick && onClick(index || 0)}
      onKeyDown={e =>
        (e.key === 'Enter' || e.key === ' ') && onClick && onClick(0)
      }
    >
      <p className={`title-bold-medium ${styles.orderTileTitle}`}>{title}</p>
      {description && (
        <p className={`title-small ${styles.orderTileDescription}`}>
          {description}
        </p>
      )}
    </div>
  )
}

export default OrderTile
